export default "__VITE_ASSET__DpQTgreu__"